import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logos/PL_NL_V_RED_RGB.png")